/**
 * Csv Schema of CargaSaraiva
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaSaraiva} from '@/model/resource/CargaSaraiva'

/* TODO: review generated schema */
export class CsvCargaSaraivaSchema extends Schema {
  readonly name = 'CsvCargaSaraiva'

  readonly fieldSet: FieldSet<CargaSaraiva> = {
    idCargaPk: schema => schema.model.idCargaPk,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    ativo: schema => Helper.bool(schema.model.ativo),
    danfe: schema => schema.model.danfe,
    notaFiscal: schema => schema.model.notaFiscal,
    nomeDestinatario: schema => schema.model.nomeDestinatario,
    documentoDestinatario: schema => schema.model.documentoDestinatario,
    enderecoDestinatario: schema => schema.model.enderecoDestinatario,
    nomeTransportador: schema => schema.model.nomeTransportador,
  }
}
